export enum EPageType {
  user = 'user',
  user_follow = 'user_follow',
  user_topic = 'user_topic',
  hashtag = 'hashtag',
  article = 'article',
  video = 'video',
  feed = 'feed',
  poi = 'poi',
  discover = 'discover',
}

export const PageTypeUtils = {
  getPageTypeFromPathname: (pathname: string): EPageType | null => {
    if (pathname.startsWith('/discover/')) {
      return EPageType.discover;
    }
    if (pathname.startsWith('/feed')) {
      return EPageType.feed;
    }
    if (pathname.startsWith('/poi')) {
      return EPageType.poi;
    }
    if (pathname.startsWith('/topic')) {
      return EPageType.hashtag;
    }
    if (pathname.match(/^\/[^\/]+\/follow/)) {
      return EPageType.user_follow;
    }
    if (pathname.match(/^\/[^\/]+\/topic/)) {
      return EPageType.user_topic;
    }

    // legacy article-i
    if (pathname.match(/^\/article\/i\d+/)) {
      return EPageType.article;
    }

    // legacy user-share
    if (pathname.match(/^\/user\/\d+\/share/)) {
      return EPageType.user;
    }

    const segmentCount = pathname.split('/').filter(Boolean).length;
    if (segmentCount === 1) {
      return EPageType.user;
    }
    if (segmentCount === 2) {
      return EPageType.article;
    }
    return null;
  },
};
